import React,{useState,useEffect} from "react";
import UserLeftPanel from "../include/UserLeftPanel";
import Header from "../include/header";
import Footer from "../include/footer";
import Global from "../../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";


function CustomerServices()
{
    const navigate = useNavigate();
    const {type} = useParams();
    const {UniqueId} = useParams();
    const [list, setList] = useState([]);
    const [showpage, setShowpage] = useState(type);
    const{headers1,headers2,logout}=AuthUser();
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    
    useEffect(()=>{
         GetServicelist(type,'');
    },[]);
    
    const GetServicelist=(type,searchvalue)=>{
        setSubloading(true);
        setShowpage(type);
        axios({
            method: 'post',
            url: Global.baseUrl+'GetServicelist',
            headers:headers1,
            data: {
                pagetype:type,
                searchvalue: searchvalue
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setSubloading(false);
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
          });
    }
    
    return (
        <>
        <UserLeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true?<MainLoader/>:
                <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="/Admin-Dash">
                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Price Master</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Domestic Price Master</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md">
                        <div className="custom_nav_data_table">
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                <button className={showpage =='All'?"nav-link active":"nav-link"} value="All" onClick={()=>GetServicelist('All','')}>All Services</button>
                                </li>
                                <li className="nav-item">
                                <button className={showpage =='Domestic'?"nav-link active":"nav-link"} value="Domestic" onClick={()=>GetServicelist('Domestic','')}>Domestic Services</button>
                                </li>
                                <li className="nav-item">
                                <button className={showpage =='International'?"nav-link active":"nav-link"} value="International" onClick={()=>GetServicelist('International','')}>International Services</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="table-settings shipment_list" id="">
                            <div className="row align-items-start g-2" >
                                <div className="col col-md ">
                                    <div className="input-group ">
                                        <input type="text" className="form-control w-50" placeholder="Search service" onChange={(e)=>GetServicelist(showpage,e.target.value)} />
                                        <span className="input-group-text">
                                            <i className="bx bx-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="data_table">
                    <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                        <table className="table table-hover">
                            <thead>
                                <tr>						
                                    <th className="border-gray-200">#</th>
                                    <th className="border-gray-200">Service Name</th>
                                    <th className="border-gray-200">Shipment Type</th>
                                    <th className="border-gray-200">Mode</th>
                                    <th className="border-gray-200">Weight Range</th>
                                    <th className="border-gray-200">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {Subloading==true && <ListLoader/>}
                            {list != undefined && Subloading==false ?
                                <>
                                {list.map((service,index)=>{
                                    return(
                                        <tr key={index}>
                                    <td><span className="fw-normal text-capitalize">{index+1}</span></td>
                                    <td><span className="fw-normal text-capitalize"><a href="">{service.services_name}</a> </span></td>
                                    <td><span className="fw-normal"><span className={service.product_type=='Parcel'? "badge bg-danger":"badge bg-warning"}>{service.product_type}</span></span></td>
                                    <td><span className="fw-normal"><span className={service.booking_type=='Domestic' ? "badge bg-primary":"badge bg-dark"}>{service.booking_type}</span></span></td>
                                    <td><span className="fw-normal text-capitalize">{service.startrange} ~ {service.endrange}KG</span></td>
                                    <td>
                                        <Link to={`/CustomerPricing/${service.unique_id}/${service.booking_type}/${UniqueId}`} className="btn btn-gray-100">Set/Update Pricing</Link>
                                        <Link to={`/CustomerOtherPricing/${service.unique_id}/${UniqueId}`} className="btn btn-gray-100">Set/Update OtherPricing</Link>
                                    </td>
                                </tr> 
                                );
                            })}   
                        </>
                            :
                            <tr>
                            <td>Record Not Found</td>
                            </tr>
                        }                    
                            </tbody>
                        </table>
                        
                    </div>
                </section>

                </>
            }
            <Footer/>
        </main>
    </>
    );

}
export default CustomerServices;